import {
  TDecedentData,
  TFeeData,
  TRealEstateData,
  TSuccessorData,
  TTrustData,
  TTrusteeData,
  TTrustsData,
  TDirectivesData,
  TTasksData,
} from "./trustTypes";

export const getDefaultTrustsData = (): TTrustsData => ({
  trust: {
    id: 0,
    type: "",
    name: "",
    date: "",
    restated: false,
    year: "",
    familyName: "",
    isSpecialNeeds: false,
    specialNeedsInstructions: "",
    perStirpesOrCapita: "",
    children: "",
    remainderBeneficiaries: "",
    omittedPersons: "",
    financialInstitutions: "",
    meetingDate: "",
    numHeirs: "",
    heir1: "",
    heir2: "",
    heir3: "",
    signingDate: "",
    signingCity: "",
    signingState: "",
    signingCounty: "",
    notaryName: "",
    notaryPhone: "",
    realtorName: "",
    realtorCompany: "",
    realtorPhone: "",
    otherNotary: "",
    otherNotary2: "",
    witness1Name: "",
    witness2Name: "",
    witness2Number: "",
    witness2Address: "",
    trustAka: "",
    notes: "",
  },
  trustees: [],
  decedent: {
    id: 0,
    trustId: 0,
    type: "",
    fullName: "",
    lastName: "",
    akaNee: "",
    aka: "",
    nee: "",
    pronoun: "",
    fullAddress: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    cityOfDeath: "",
    countyOfDeath: "",
    phone: "",
    email: "",
    dob: "",
    ssn: "",
    ein: "",
    relationship: "",
    age: "",
    dod: "",
    day41: "",
    yearsInResidence: "",
    driverLicenseNumber: "",
    driverLicenseExpirationDate: "",
  },
  successors: [],
  directives: [],
  realEstate: [],
  fees: {
    id: 0,
    trustId: 0,
    trustDocsCost: "",
    paid: "",
    balanceDue: "",
    dueToNotary: "",
    paymentDate: "",
    paymentType: "",
    paymentDueDate: "",
  },
  tasks: {
    id: 0,
    trustId: 0,
    isClientTexted: false,
    isNewClientEmailed: false,
    isDataInput: false,
    isDraftSent: false,
    isDateOfTrustSet: false,
    isNotarized: false,
    isVideoCompleted: false,
    isFeePaid: false,
    isDeedRecorded: false,
    deedRecordedDate: "",
    isDeedEmailedToClient: false,
    isDeedMailedToClient: false,
    deedMailedDate: "",
    isBeneficiaryUpdated: false,
    isWitnessed: false,
    isScanned: false,
    isTrustEmailed: false,
    isVideoEmailed: false,
    isHmstEmailedToClient: false,
    isADTEmailedToClient: false,
    isReceiptEmailedToClient: false,
    isPCOREmailedToClient: false,
    isADTMailedToClient: false,
  },
});

export const getDefaultTrustData = (): TTrustData => ({
  id: 0,
  type: "",
  name: "",
  date: "",
  restated: false,
  year: "",
  familyName: "",
  isSpecialNeeds: false,
  specialNeedsInstructions: "",
  perStirpesOrCapita: "",
  children: "",
  remainderBeneficiaries: "",
  omittedPersons: "",
  financialInstitutions: "",
  meetingDate: "",
  numHeirs: "",
  heir1: "",
  heir2: "",
  heir3: "",
  signingDate: "",
  signingCity: "",
  signingState: "",
  signingCounty: "",
  notaryName: "",
  notaryPhone: "",
  realtorName: "",
  realtorCompany: "",
  realtorPhone: "",
  otherNotary: "",
  otherNotary2: "",
  witness1Name: "",
  witness2Name: "",
  witness2Number: "",
  witness2Address: "",
  trustAka: "",
  notes: "",
});

export const getDefaultTrusteeData = (): TTrusteeData => ({
  id: 0,
  trustId: 0,
  type: "",
  fullName: "",
  signingName: "",
  lastName: "",
  akaNee: "",
  aka: "",
  nee: "",
  pronoun: "",
  fullAddress: "",
  street: "",
  city: "",
  state: "",
  zip: "",
  phone: "",
  email: "",
  dob: "",
  ssn: "",
  relationship: "",
  age: "",
  dod: "",
  day41: "",
  yearsInResidence: "",
  driverLicenseNumber: "",
  driverLicenseExpirationDate: "",
});

export const getDefaultDecedentData = (): TDecedentData => ({
  id: 0,
  trustId: 0,
  type: "Decedent",
  fullName: "",
  lastName: "",
  akaNee: "",
  aka: "",
  nee: "",
  pronoun: "",
  fullAddress: "",
  street: "",
  city: "",
  state: "",
  zip: "",
  cityOfDeath: "",
  countyOfDeath: "",
  phone: "",
  email: "",
  dob: "",
  ssn: "",
  ein: "",
  relationship: "",
  age: "",
  dod: "",
  day41: "",
  yearsInResidence: "",
  driverLicenseNumber: "",
  driverLicenseExpirationDate: "",
});

export const getDefaultDirectivesData = (): TDirectivesData => ({
  id: 0,
  trustId: 0,
  number: 0,
  description: "",
});

export const getDefaultSuccessorData = (): TSuccessorData => ({
  id: 0,
  trustId: 0,
  type: "",
  fullName: "",
  lastName: "",
  akaNee: "",
  fullAddress: "",
  street: "",
  city: "",
  state: "",
  zip: "",
  phone: "",
  email: "",
  dob: "",
  ssn: "",
  relationship: "",
  age: "",
  dod: "",
  day41: "",
  yearsInResidence: "",
});

export const getDefaultRealEstateData = (): TRealEstateData => ({
  id: 0,
  trustId: 0,
  apn: "",
  fullAddress: "",
  street: "",
  city: "",
  state: "",
  zip: "",
  county: "",
  grantor1: "",
  grantor2: "",
  grantorTitle: "",
  description: "",
  documentNumber: "",
  isPrimary: false,
});

export const isRealEstateEmpty = (re: TRealEstateData): boolean =>
  !re.apn &&
  !re.fullAddress &&
  !re.street &&
  !re.city &&
  !re.state &&
  !re.zip &&
  !re.county &&
  !re.grantor1 &&
  !re.grantor2 &&
  !re.grantorTitle &&
  !re.description &&
  !re.documentNumber;

export const getDefaultFeesData = (): TFeeData => ({
  id: 0,
  trustId: 0,
  trustDocsCost: "",
  paid: "",
  balanceDue: "",
  dueToNotary: "",
  paymentDate: "",
  paymentType: "",
  paymentDueDate: "",
});

export const getDefaultTasksData = (): TTasksData => ({
  id: 0,
  trustId: 0,
  isClientTexted: false,
  isNewClientEmailed: false,
  isDataInput: false,
  isDraftSent: false,
  isDateOfTrustSet: false,
  isNotarized: false,
  isVideoCompleted: false,
  isFeePaid: false,
  isDeedRecorded: false,
  deedRecordedDate: "",
  isDeedEmailedToClient: false,
  isDeedMailedToClient: false,
  deedMailedDate: "",
  isBeneficiaryUpdated: false,
  isWitnessed: false,
  isScanned: false,
  isTrustEmailed: false,
  isVideoEmailed: false,
  isHmstEmailedToClient: false,
  isADTEmailedToClient: false,
  isReceiptEmailedToClient: false,
  isPCOREmailedToClient: false,
  isADTMailedToClient: false,
});
